
import type { UniClub as Club } from "../types";

/** Escaping CSV basique (RFC 4180): double quotes autour et doublement des guillemets internes */
function csvEscape(value: unknown): string {
  const s = value == null ? "" : String(value);
  const needsQuotes = /[",\n\r;]/.test(s); // inclut ; si tu veux un CSV "point-virgule"
  const escaped = s.replace(/"/g, '""');
  return needsQuotes ? `"${escaped}"` : escaped;
}

/**
 * Exporte {id, nom, lieu, email, site} en CSV.
 * Par défaut, séparateur = ; (courant en FR/BE) et BOM UTF-8 pour Excel.
 */
export function exportClubsToCsv(
  clubs: Club[],
  fileName = "clubs-export.csv",
  separator: "," | ";" = ";"
) {
  const header = ["id", "nom", "lieu", "email", "site"];
  const rows = clubs.map(({ id, nom, lieu, email, site }) => [
    id ?? "", nom ?? "", lieu ?? "", email ?? "", site ?? ""
  ]);

  // Construit le CSV
  const lines = [
    header.join(separator),
    ...rows.map(r => r.map(csvEscape).join(separator)),
  ];
  const csv = lines.join("\r\n");

  // Ajoute BOM pour Excel afin d'éviter les soucis d’accents
  const BOM = "\uFEFF";
  const blob = new Blob([BOM + csv], { type: "text/csv;charset=utf-8" });
  const url = URL.createObjectURL(blob);

  const a = document.createElement("a");
  a.href = url;
  a.download = fileName;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}
